module.exports = __webpack_public_path__ + "statics/img/11.3a94f2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home/11.png
// module id = 6iNf
// module chunks = 1